export default {
	colors_() {
		return ['#13C7A3', '#89FB89', '#82F0F0', '#99CCFF', '#A0DFE1', '#6FCC98', '#AAEBAA'];
	},
	stackedLabel_: ({ graphList }) => {
		const labelArray = [];
		for (const item of graphList) {
			labelArray.push(item.occuDd);
		}
		return labelArray;
	},
	stackedDataSet_: ({ graphList }, getters, rootState, rootGetters) => {
		const barCku = [],
			barIpgo = [],
			lineBad = [];

		for (const val of graphList) {
			barCku.push(val.ckuBadQty);
			barIpgo.push(val.osndBadQty);
			lineBad.push(val.badRate);
		}
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001234'), //불량율,
				data: lineBad,
				borderColor: '#9AB9FF',
				backgroundColor: '#E8F5FF',
				type: 'line',
				order: 0
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001234'), //입고불량,
				data: barCku,
				borderColor: '#FF7E9D',
				backgroundColor: '#FFF0F5',
				type: 'line',
				order: 1
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000073'), //공정불량,
				data: barIpgo,
				borderColor: '#CE69E7',
				backgroundColor: '#CE69E7',
				borderWidth: 1,
				order: 2
			}
		];
	},
	getColumnsLeft_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002052'), //rank
				prop: 'rank',
				minWidth: '40px',
				align: 'center'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000951'), //업체
				prop: 'cofNm',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000074'), //불량수량
				prop: 'badQty',
				align: 'right'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002053') + ' (%)', //점유율
				prop: 'badShare',
				align: 'right'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002054'), //검사/투입수량
				prop: 'ckuQty',
				align: 'right'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001234') + ' (%)', //불량율
				prop: 'badRate',
				align: 'right'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002055'), //불량의뢰건수
				prop: 'cofCnt',
				align: 'right'
			}
		];
	},
	getColumnsRight_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000956'), //품번
				prop: 'partNm',
				minWidth: '120px'
			},
			{
				label: 'PRR NO.', //PRR NO.
				prop: 'pprNo',
				minWidth: '150px',
				custom: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002054'), //검사/투입수량
				prop: 'ckuQty',
				align: 'right'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000074'), //불량수량
				prop: 'badQty',
				align: 'right'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001234') + ' (%)', //불량률
				prop: 'badRate',
				align: 'right'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002056'), //불량보고서상태
				prop: 'pgsStNm',
				align: 'center'
			}
		];
	}
};
